"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const config_1 = require("../../config/config");
const styles = (theme) => (0, core_1.createStyles)({
    backButton: {
        marginTop: theme.spacing(2),
        marginLeft: -theme.spacing(),
        '& span': {
            textTransform: 'none',
            color: theme.palette.text.secondary
        }
    },
    center: {
        display: 'flex',
        alignItems: 'center'
    },
    button: {
        paddingTop: theme.spacing() + 4,
        paddingBottom: theme.spacing() + 4,
        marginLeft: theme.spacing()
    },
    leftIcon: {
        marginRight: theme.spacing()
    },
    warningButton: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' },
    signInIcon: { width: '50px', height: '50px', background: config_1.config.themeColors.warningBackgroundColor.hex(), borderRadius: '25px', marginRight: theme.spacing() },
    header: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
    headerTitle: { width: '90%' }
});
exports.default = styles;
//# sourceMappingURL=DetailTitleStyle.js.map